export default {
  complete: {
    download: 'Download Employment Contract Documents',
    downloading: 'Downloading...',
    subtitle: 'Signature Completed',
    title: 'Employment Contract Documents',
  },
  confirmation: {
    back: 'Back',
    confirm: 'Confirm Signature',
    documentsLabel: 'Documents to Sign',
    pageTitle: 'Review and Sign Employment Contract Documents',
    signatureLabel: 'Signature',
    submitting: 'Submitting...',
    title: 'Final Confirmation',
  },
  footer: {
    confirmAndProceed: 'Confirm and Proceed',
    reject: 'Reject',
  },
  header: {
    title: 'Review and Sign Employment Contract Documents',
  },
  pdfViewer: {
    selectDocument: 'Please select a document to view',
    viewerTitle: 'PDF Viewer',
  },
  rejectComplete: {
    description:
      'You have rejected the signature request. Please contact the company if you have any questions.',
    subtitle: 'Rejection Completed',
    title: 'Employment Contract Documents',
  },
  rejectDialog: {
    cancel: 'Cancel',
    reasonLabel: 'Rejection Reason',
    reasonPlaceholder: 'Enter the reason for rejection',
    submit: 'Submit',
    submitting: 'Submitting...',
    title: 'Enter Rejection Reason',
  },
  signatureDialog: {
    cancel: 'Cancel',
    nameLabel: 'Name',
    namePlaceholder: 'Enter your name',
    next: 'Next',
    title: 'Enter Signature Information',
  },
};
